"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const uuid_1 = require("uuid");
// @todo delegate to react useId hook when React 18 is minimally supported
const useId = () => {
    const ref = (0, react_1.useRef)(null);
    const getUniqueId = () => {
        if (ref.current === null) {
            ref.current = (0, uuid_1.v4)();
        }
        return ref.current;
    };
    return getUniqueId();
};
exports.default = useId;
